<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="8vh"
      :z-index="2000" :before-close="handleClose" @open="onDialogOpen">
      <template #title>
        <span>{{`${isEdit ? "编辑" : "添加"}VIP课程记录`}}</span>
      </template>
      <div class="backgroud-white cs-editor-content" v-loading="loading">
        <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="110px">
          <el-form-item label="学生电话" prop="StudentPhone">
            <el-input placeholder="请输入学生电话" :disabled="readonly || isEdit" v-model="model.StudentPhone" class="input-width"
              @keyup.enter.native="searchStudent()">
              <template #append>
                <el-button v-if="!readonly && !isEdit" size="small" type="primary" @click="searchStudent()">搜索</el-button>
              </template>
            </el-input>

          </el-form-item>
          <el-form-item label="课时消耗日期" prop="ConsumedDate">
            <el-date-picker align="center" type="date" format="yyyy/MM/dd" :disabled="readonly" v-model="model.ConsumedDate" placeholder="请选择使用日期"
              class="input-width" />
          </el-form-item>
          <el-form-item label="课程" prop="WorkflowCourseId">
            <div class="vip-course-select-wrap" :class="{ 'has-value': !!selectedWorkflowCourse }">
              <el-select @change="onWorkflowCourseChange" :disabled="readonly" v-model="model.WorkflowCourseId" placeholder="请选择课程" class="input-width"
                :title="getWorkflowCourseTooltip(model.WorkflowCourseId)">
                <el-option v-for="item in vipWorkflowCourseList" :key="item.Id" :value="item.Id" :label="getWorkflowCourseText(item)"
                  :disabled="item.isDisabled">
                  <span>{{ getWorkflowCourseBaseText(item) }}</span>
                  <span v-if="item.HasDebt" class="cs-redLabel">{{ debtMark }}</span>
                </el-option>
              </el-select>
              <div v-if="selectedWorkflowCourse" class="vip-course-selected-label" :class="{ 'is-disabled': readonly }">
                <span class="vip-course-selected-text">{{ getWorkflowCourseBaseText(selectedWorkflowCourse) }}</span>
                <span v-if="selectedWorkflowCourse.HasDebt" class="vip-course-debt-mark">
                  <span class="cs-redLabel">{{ debtMark }}</span>
                </span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="课程备注名" prop="CourseAlias" v-if="!hasCourseAlias">
            <el-input placeholder="请输入课程备注名" :disabled="readonly" v-model="model.CourseAlias" class="input-width">
            </el-input>
          </el-form-item>
          <el-form-item label="消耗课时(分钟)" prop="CourseMinutesConsumed">
            <el-input-number placeholder="请输入消耗课时(分钟)" :precision="0" :step="1" :min="0" :max="9999"
               v-model="model.CourseMinutesConsumed" size="small" :disabled="readonly"></el-input-number>
            <!-- <el-input placeholder="请输入消耗课时(分钟)" size="small" :disabled="readonly" v-model="model.CourseMinutesConsumed" class="input-width"
              oninput="value=value.replace(/[^0-9]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(0):null">
            </el-input> -->
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer popup-footer">
          <el-row>
            <el-col>
              <el-button :disabled="readonly || loading || isSaving" :loading="isSaving" type="primary" @click="saveChanges">确认</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { getStudentMemberInfo } from "@/service/student.service";
import {
  getVipWorkflowCoursesByStudentId,
  saveStudentVipCourseRecord,
} from "@/service/enrollmentFee.service";

const mixinGeneralMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
    calcCourseItemAvailableOffset(item) {
      if (!this.model.Id || !this.data) return 0;

      return item.Id === this.data.WorkflowCourseId
        ? this.data.CourseMinutesConsumed
        : 0;
    },
    calcCourseItemDisabled(item) {
      let isDisabled = !item.CourseMinutesAvailable &&
        (!this.data || this.data.WorkflowCourseId != item.Id);
      return isDisabled;
    },
    getWorkflowCourseBaseText(item) {
      if (!item) return "";

      return `${item.CourseGroupName}[总${item.CourseMinutesTotal}分钟，剩余${
        item.CourseMinutesAvailable + this.calcCourseItemAvailableOffset(item)
      }分钟]`;
    },
    getWorkflowCourseText(item) {
      if (!item) return "";

      let text = this.getWorkflowCourseBaseText(item);
      if (item.HasDebt) {
        text += this.debtMark;
      }
      return text;
    },
    getWorkflowCourseTooltip(workflowCourseId) {
      let matchedItem = this.vipWorkflowCourseList.find(
        (item) => item.Id === workflowCourseId
      );
      return this.getWorkflowCourseText(matchedItem);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.contains(queryString);
      };
    },
    onCourseAliasFetchSuggestions(queryString, cb) {
      let workflowCourse = this.vipWorkflowCourseList.find(
        (item) => item.Id === this.model.WorkflowCourseId
      );
      if (!workflowCourse) {
        cb([]);
        return;
      }

      let restaurants = workflowCourse.UsedCourseAliasList.map((item) => ({
        value: item,
      }));
      let results = !!queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
  },
};

const default_dataModel = {
  Id: 0,
  StudentId: 0,
  StudentPhone: null,
  TermId: 0,
  ConsumedDate: moment(new Date().format("yyyy-MM-dd")),
  WorkflowCourseId: null,
  CourseAlias: null,
  CourseMinutesConsumed: null,
};

export default {
  name: "studentVipCourseRecordEditor",
  mixins: [mixinGeneralMethods],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "50%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(default_dataModel);
      },
    },
    termId: {
      type: Number,
      default: 0,
    },
    student: {
      type: Object,
      default: () => null,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      if (this.isEdit) {
        callback();
      }
      if (!!value) {
        value = value.trim();
      }

      let message = "";
      let pattern = /^\d{10,11}$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的手机号码";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let courseMinutesConsumedValidator = (rule, value, callback) => {
      let numValue = `${value}`.toNumber();
      if (!numValue) {
        return callback(new Error("请输入消耗课时(分钟)"));
      }

      let selectedCourse = this.vipWorkflowCourseList.find(
        (item) => item.Id == this.model.WorkflowCourseId
      );
      if (!selectedCourse) {
        return callback(new Error("请先选择课程"));
      }

      let courseMinutesAvailable = selectedCourse.CourseMinutesAvailable;
      if (!!this.data && this.data.Id > 0)
        courseMinutesAvailable =
          courseMinutesAvailable + this.data.CourseMinutesConsumed;
      if (numValue > courseMinutesAvailable) {
        return callback(new Error("已消耗课时数不能大于可用课时数"));
      }

      return callback();
    };

    return {
      hasCourseAlias: true,
      loading: false,
      isSaving: false,
      dialogVisible: false,
      rules: {
        StudentPhone: [
          {
            required: true,
            message: "请输入学生电话",
            trigger: "blur",
          },
          {
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        ConsumedDate: [
          {
            required: true,
            message: "请选择课时消耗日期",
            trigger: "blur",
          },
        ],
        WorkflowCourseId: [
          {
            required: true,
            message: "请选择课程",
            trigger: "blur",
          },
        ],
        CourseMinutesConsumed: [
          {
            validator: courseMinutesConsumedValidator,
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(default_dataModel),
      vipWorkflowCourseList: [],
      debtMark: " （有欠款）",
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    isEdit() {
      return !!this.data && !!this.data.Id;
    },
    selectedWorkflowCourse() {
      return (
        this.vipWorkflowCourseList.find(
          (item) => item.Id == this.model.WorkflowCourseId
        ) || null
      );
    },
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async loadStudentMemberInfo() {
      this.loading = true;
      try {
        let result = await getStudentMemberInfo(null, this.model.StudentPhone);

        if (result && result.success) {
          this.model.StudentId = result.data.StudentId;
        } else {
          this.model.StudentId = 0;
          this.$message.error(result.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async loadVipWorkflowCoursesByStudentIdFromServer() {
      this.loading = true;
      try {
        let termId = this.termId;
        let studentId = this.model.StudentId;
        let id = null;
        if (this.data && this.data.Id) {
          id = this.data.Id;
        }
        let result = await getVipWorkflowCoursesByStudentId(
          termId,
          studentId,
          id
        );
        let list = !!result && result.success ? result.data : [];
        list.forEach(item => {
          item.isDisabled = !item.CourseMinutesAvailable &&
            (!this.data || this.data.WorkflowCourseId != item.Id);
        });

        this.vipWorkflowCourseList = list;
        if (!this.model.Id && this.vipWorkflowCourseList.length > 0) {
          let items = this.vipWorkflowCourseList.filter(i => !i.isDisabled);
          if (items.length > 0){
            this.model.WorkflowCourseId = items[0].Id;
          }
        }
        let index = this.vipWorkflowCourseList.findIndex(
          (i) => i.Id == this.model.WorkflowCourseId
        );
        if (index < 0) {
          this.model.WorkflowCourseId = "";
        }
        this.checkCourseAlias();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async saveStudentVipCourseRecordToServer() {
      this.isSaving = true;
      let saveData = Object.clone(this.model);
      //saveData.ConsumedDate = this.$moment(saveData.ConsumedDate.toDate());
      if (!saveData.Id) {
        saveData.TermId = this.termId;
        saveData.StudentId = this.model.StudentId;
      }

      try {
        let result = await saveStudentVipCourseRecord(saveData);
        if (!!result && result.success) {
          this.model.Id = result.data;
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.$emit("change", this.model);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    resetData() {
      this.model = Object.clone(default_dataModel);
      this.vipWorkflowCourseList = [];

      this.$nextTick(() => {
        let refForm = this.$vueRefStore.getChildrenRef("form");
        if (!!refForm) {
          refForm.resetFields();
        }
      });
    },
    async reloadDataFromProps() {
      if (!this.dialogVisible) return;

      this.model = Object.clone(this.data || default_dataModel);
      this.model.ConsumedDate = this.$moment.utc(this.model.ConsumedDate);

      if (!this.isEdit && !!this.student && !!this.student.studentId) {
        this.model.StudentPhone = this.student.phone;
        this.model.StudentId = this.student.studentId;
      }

      await this.loadVipWorkflowCoursesByStudentIdFromServer();
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    async closeDialog() {
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(() => {
        this.resetData();

        this.closeDialog();
      });
    },
    async searchStudent() {
      await this.loadStudentMemberInfo();
      if (!this.model.StudentId) {
        this.vipWorkflowCourseList = [];
        return;
      }

      await this.loadVipWorkflowCoursesByStudentIdFromServer();
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      if (!this.model.StudentId) {
        this.$message.error("未找到学生");
        return;
      }

      this.$nextTick(async () => {
        await this.saveStudentVipCourseRecordToServer();
        this.closeDialog();
      });
    },
    onWorkflowCourseChange() {
      this.checkCourseAlias();
    },
    checkCourseAlias() {
      let item = this.vipWorkflowCourseList.find(
        (i) => i.Id == this.model.WorkflowCourseId
      );
      if (item) {
        this.hasCourseAlias = item.HasCourseAlias;
        if (this.hasCourseAlias) {
          this.model.CourseAlias = item.CourseAlias;
        } else {
          this.model.CourseAlias = "";
        }
      } else {
        this.hasCourseAlias = true;
      }
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }
  }
}

.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }
  }
}

.vip-course-select-wrap {
  position: relative;
  width: 100%;

  &.has-value {
    /deep/ .el-input__inner {
      color: transparent;
    }
  }

  .vip-course-selected-label {
    position: absolute;
    z-index: 1;
    left: 15px;
    right: 30px;
    top: 0;
    height: 40px;
    display: flex;
    align-items: center;
    pointer-events: none;
    overflow: hidden;
    color: #606266;
    font-size: 14px;

    &.is-disabled {
      color: #c0c4cc;
    }
  }

  .vip-course-selected-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  .vip-course-debt-mark {
    flex: none;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/addCollectFees/studentVipCourseRecordEditor.vue